<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelIdioma"
    select-label=""
    selected-label="«"
    deselect-label=""
    :allow-empty="false"
    :preselect-first="false"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="singleLabel" slot-scope="{ option }">
      <div class="flag-option">
        <flag :iso="option.iso2" :squared="false" />
        <span class="flag-text">{{ option.idioma }}</span>
      </div>
    </template>
    <template slot="option" slot-scope="{ option }">
      <div class="flag-option">
        <flag :iso="option.iso2" :squared="false" />
        <span class="flag-text">{{ option.idioma }}</span>
      </div>
    </template>
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ emptyLabel }}</span>
    </template>
  </multiselect>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'idioma', null);
        return;
      }
      let idioma = e.idioma;
      this.$emit('selectChange', 'idioma', idioma);
    },
    labelIdioma(option) {
      const nome = option.idioma;
      return nome;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.idioma == value);
      } else {
        this.selected = this.options.find((option) => option.idioma === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      let filtro = 'detalhes IS NOT NULL ';
      filtro += `
        AND (
          detalhes ->> 'idiomas' LIKE '%"es-%"%'
          OR detalhes ->> 'idiomas' LIKE '%"en-%"%'
          OR detalhes ->> 'idiomas' LIKE '%"pt-%"%'
        )
      `;
      this.$atenaList
        .getPaises({ filter: filtro, columns: '*', order: 'detalhes' })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ idioma: this.$i18n.t(this.emptyLabel) }];
          }
          res.data.forEach((item) => {
            let detalhes = JSON.parse(item.detalhes);
            detalhes.idiomas.forEach((idioma) => {
              if (idioma.startsWith('en') || idioma.startsWith('es') || idioma.startsWith('pt')) {
                this.options.push({
                  id: item.id,
                  iso2: item.iso2,
                  idioma: idioma
                });
              }
            });
          });

          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: 'Erro ao Carregar Dados',
            msgContent: 'Entre em contato com o Administrador do Sistema.',
            type: 'error'
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped>
.flag-option {
  display: flex;
  align-items: center;
}
.flag-text {
  margin-left: 8px;
}
</style>
